const APP_VERSION = '1783006388438';
export default APP_VERSION;
